import { PropsWithChildren, useEffect, useState } from 'react';
import ConfettiExplosion, { ConfettiProps } from 'react-confetti-explosion';
import { Colors } from '@zep/ui-tokens';
interface ConfettiExplosionWrapperProps extends Partial<ConfettiProps> {
  triggerOnMount?: boolean;
}
export const ConfettiExplosionWrapper = ({
  triggerOnMount = true,
  onComplete,
  children,
  colors = [Colors.PrimaryDefault, Colors.PrimaryGradient, Colors.MintDefault],
  // 기본 색상 설정
  force = 0.8,
  // 기본 force 값
  duration = 3000,
  // 기본 duration 값
  particleCount = 100,
  // 기본 particleCount 값
  className = 'fixed left-1/2 top-1/4',
  // 기본 className 값
  width = 3000,
  // 기본 width 값
  particleSize = 10,
  ...rest
}: PropsWithChildren<ConfettiExplosionWrapperProps>) => {
  const [isExploding, setIsExploding] = useState(false);
  useEffect(() => {
    if (triggerOnMount) {
      setIsExploding(true);
    }
    return () => {
      if (onComplete) onComplete();
    };
  }, [triggerOnMount, onComplete]);
  return <>
      {isExploding && <ConfettiExplosion colors={colors} force={force} duration={duration} particleCount={particleCount} className={className} width={width} particleSize={particleSize} {...rest} />}
      {children}
    </>;
};